var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"md6":"","shrink":""}},[_c('h1',{staticClass:"title title-rule"},[_vm._v("Daniel Devine")]),_c('div',{staticClass:"subtitle-black"},[_vm._v("Full Stack developer based in Brisbane, Australia.")])])}
var staticRenderFns = []

export { render, staticRenderFns }